export const textWithBreaklineHtml = text => String(text || '').replace(/\\n/gi, '<br>')
